import { useRef, forwardRef, useImperativeHandle } from 'react';
import { motion } from 'framer-motion';

const Card3D = forwardRef(({ card, isFlipped, rotation, isSelected }, ref) => {
  const cardRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getCardElement: () => cardRef.current
  }));

  const cardStyle = {
    transform: `rotateY(${rotation.y}deg) rotateX(${rotation.x}deg)`,
    transition: 'transform 0.1s ease-out'
  };

  const glowStyle = {
    boxShadow: `0 0 30px ${card ? card.theme.glowColor : 'rgba(59, 130, 246, 0.5)'}, 0 0 60px ${card ? card.theme.glowColor : 'rgba(59, 130, 246, 0.3)'}`
  };

  return (
    <div 
      ref={cardRef}
      className="relative w-64 h-96 perspective-1000 cursor-pointer"
      style={card ? glowStyle : {}}
    >
      <motion.div
        className="w-full h-full preserve-3d"
        style={cardStyle}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ 
          scale: isSelected ? 1.1 : 1, 
          opacity: isFlipped ? 1 : 0.8 
        }}
        transition={{ duration: 0.5 }}
      >
        <div className="absolute w-full h-full backface-hidden">
          <div 
            className={`w-full h-full rounded-2xl bg-gradient-to-br ${card ? card.theme.gradient : 'from-blue-500 to-purple-600'} 
                       flex flex-col items-center justify-center p-6 text-white relative overflow-hidden`}
          >
            <div className="absolute inset-0 bg-black/20" />
            
            {!isFlipped ? (
              <>
                <div className="text-6xl mb-4 relative z-10">
                  {card ? card.icon : '🎴'}
                </div>
                <div className="text-xl font-bold relative z-10 text-center">
                  {card ? card.theme.name : '准备抽卡'}
                </div>
                <div className="mt-4 text-sm relative z-10 opacity-80 text-center">
                  {card ? '点击或握拳准备' : '请面对摄像头'}
                </div>
              </>
            ) : (
              <>
                <div className="text-8xl mb-4 relative z-10 animate-float">
                  {card?.icon || '🎉'}
                </div>
                <h2 className="text-2xl font-bold mb-3 relative z-10 text-center leading-tight">
                  {card?.title || '恭喜获得'}
                </h2>
                <div className="w-16 h-1 bg-white/30 rounded-full mb-4 relative z-10" />
                <p className="text-sm relative z-10 text-center leading-relaxed opacity-90">
                  {card?.content || '这是属于你的独特卡片'}
                </p>
              </>
            )}
            
            <div className="absolute bottom-4 left-4 right-4 flex justify-between items-center relative z-10">
              <span className="text-xs opacity-60">
                {card ? `#${card.id}` : '?'}
              </span>
              <span className="text-xs opacity-60">
                {card ? card.theme.name : 'Card'}
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
});

Card3D.displayName = 'Card3D';

export default Card3D;
